const API_ROUTES = {

  /**
       * @section AUTH
       * Endpoints para la autenticación de usuarios.
       */
  auth: {
    login: '/auth/login',
    refreshToken: '/auth/refresh-token',
    logout: '/auth/logout',
    requestReset: '/auth/request-reset',
    resetPassword: '/auth/reset-password',
  },

  /**
   * @section USERS
   * Endpoints para la gestión de usuarios (abogados) del sistema.
   * Generalmente, solo accesibles para roles de administrador.
   */
  users: {
    list: '/users/listUsers',
    create: '/users/createUser',
    getById: (id: number | string): string => `/users/getUserById/${id}`,
    update: (id: number | string): string => `/users/updateUser/${id}`,
    delete: (id: number | string): string => `/users/deleteUser/${id}`,
  },

  /**
   * @section CLIENTES (Expedientes)
   * Endpoints para la gestión del núcleo de la aplicación: los expedientes.
   */
  clientes: {
    create: '/clientes/create',
    update: (id: number | string): string => `/clientes/update/${id}`,
    delete: (id: number | string): string => `/clientes/delete/${id}`,
    /**
     * Obtiene el "Dossier" completo de un caso: datos, pagos y audiencias.
     */
    getDetails: (id: number | string): string => `/clientes/detail/${id}`,
    /**
     * Actualiza el estado de un caso (Activo, En Archivo, Cerrado).
     */
    updateStatus: (id: number | string): string => `/clientes/updateStatus/${id}`,
    /**
     * Obtiene una lista de casos filtrada por su estado.
     * @param estado - 'Activo', 'En Archivo', 'Cerrado', 'Consulta'.
     */
    listByStatus: (estado: 'Activo' | 'En Archivo' | 'Cerrado' | 'Consulta' = 'Activo'): string =>
      `/clientes/listByStatus?estado=${estado}`,
    /**
     * Busca expedientes por nombre, DNI o número de expediente.
     * @param term - El término de búsqueda.
     */
    search: (term: string): string => `/clientes/search?term=${encodeURIComponent(term)}`,
    /**
     * Dispara el envío de un resumen del caso por correo al cliente.
     */
    sendSummaryEmail: (id: number | string): string => `/clientes/sendSummary/${id}`,
  },

  /**
   * @section PAGOS
   * Endpoints para gestionar las transacciones financieras de un caso.
   */
  pagos: {
    /**
     * Registra un nuevo pago asociado a un caso.
     */
    create: '/pagos/create',
    /**
     * Elimina un registro de pago.
     */
    delete: (id: number | string): string => `/pagos/delete/${id}`,
  },

  /**
   * @section AUDIENCIAS
   * Endpoints para gestionar la agenda de un caso.
   */
  audiencias: {
    create: '/audiencias/create',
    update: (id: number | string): string => `/audiencias/update/${id}`,
    delete: (id: number | string): string => `/audiencias/delete/${id}`,
  },

  /**
   * @section DASHBOARD
   * Endpoint para obtener el resumen de datos de la página principal.
   */
  dashboard: {
    getSummary: '/dashboard/getSummary',
  },

  /**
   * @section REPORTES
   * Endpoints dedicados a la generación de archivos Excel.
   * Estos endpoints devuelven un archivo para descargar, no un JSON.
   */
  reportes: {
    /**
     * Genera un reporte detallado "Kardex" de un caso específico.
     */
    generarKardex: (id: number | string): string => `/reportes/kardex/${id}`,
    /**
     * Genera un reporte financiero de ingresos en un rango de fechas.
     * @param startDate - Fecha de inicio en formato 'YYYY-MM-DD'.
     * @param endDate - Fecha de fin en formato 'YYYY-MM-DD'.
     */
    generarFinanciero: (startDate: string, endDate: string): string =>
      `/reportes/financiero?start_date=${startDate}&end_date=${endDate}`,
  },
};

export default API_ROUTES;